export default "__VITE_ASSET__B2FaQ5M3__"